export class AuthService {
    setAuthToken(token) {
        this.api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        localStorage.setItem('authToken', token);
    }
    getAuthToken() {
        return localStorage.getItem('authToken');
    }
    clearAuthToken() {
        delete this.api.defaults.headers.common['Authorization'];
        localStorage.removeItem('authToken');
    }
    initializeAuth() {
        const token = this.getAuthToken();
        if (token) {
            this.api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
    }
}
//# sourceMappingURL=AuthService.js.map